import {Pipe, PipeTransform} from '@angular/core';
import {Case} from '../../../_models/case.model';

@Pipe({
  name: 'needsReviewFilter'
})
export class NeedsReviewFilterPipe implements PipeTransform {

  transform(cases: Case[], isApplied: boolean): Case[] {
    if (isApplied) {
      return cases.filter(item => item.caseStatus === 'Needs Review');
    }
    return cases;
  }
}
